<template>
     <div class="tenantagreement-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Financial Detailing" 
                />
          <b-card class="tenantagreement-search-card">
                    <b-tabs card vertical >
                        <b-tab title="Financial Detail" active>
                        <b-form>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            :per-page="perPage" 
                            :current-page="currentPageFinancial" 
                            head-variant="light" 
                            :items="tenantagreementfinancialdetails" 
                            :fields="fielsFinancial">
                              <template v-slot:cell(actions)="data">
                                 <b-button 
                                    title="Payment Receipt" 
                                    size="sm" 
                                    variant="light" 
                                    v-if="data.item.form_payment_financial_detail > 0"
                                    @click="printerPaymentReceipt(data.item)" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                              </template>
                        </b-table>
                        </transition>   
                        <b-pagination
                           v-show="showTable"
                            v-model="currentPageFinancial"
                            :total-rows="rowsFinancial"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>                          
                            </b-row>
                        </b-form>

                        </b-tab >
                    </b-tabs>         
                </b-card>     
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'TenantFinancial',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                file: null,
                tenantagreementfinancialdetail:{},
                tenantagreementfinancialdetails:[],
                perPage: 20,
                currentPage: 1,
                currentPageFinancial: 1,
                currentPageFinancialSearch: 1,
                 isBusy: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
             
                fielsFinancial:[
                    {
                        key: 'due_date_financial_detail',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_finacial_detail', label: 'Value', sortable: false },
                     {
                        key: 'receipt_date_financial_detail',label: 'Receipt Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    {
                        key: 'form_payment_financial_detail',
                        label: 'Form of Payment',
                        sortable: true,
                        variant: 'light',
                        formatter: value => (value ? this.returnOptionFinancial(value) : '')
                    },
                    { key: 'comments_financial_detail', label: 'Notes', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
              
                 optionsPayment: [
                    { item: 1, name: 'Cash' },
                    { item: 2, name: 'Bank Transfer' }
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rowsFinancial() {
                return this.tenantagreementfinancialdetails.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            returnOptionFinancial(value) {

                   let descrition_task = ''

                    if(value ===1)
                    {
                        descrition_task = 'Cash'
                    }
                    else if(value === 2)
                    {
                        descrition_task = 'Bank Transfer'
                    }


                return descrition_task
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/tenantagreementfinancialdetailbyuser/${this.user.id}`
                axios(url).then(res =>{
                     this.tenantagreementfinancialdetails = res.data
                })
            },
            async printerPaymentReceipt(item) {
    
            const url = `${baseApiUrl}/tenantpaymentreceiptprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            async printerAgreement(item) {
    
            const url = `${baseApiUrl}/tenantagreementprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            async saveFinancial() {

                    if(!this.tenantagreementfinancialdetail.id > 0){
                        this.tenantagreementfinancialdetail.company_id_financial_detail = this.compan.id
                        this.tenantagreementfinancialdetail.tenant_agreement_id_financial_detail = this.tenantagreement.id

                    }
             
                    const method = this.tenantagreementfinancialdetail.id ? 'put' : 'post'
                    const id = this.tenantagreementfinancialdetail.id ? `/${this.tenantagreementfinancialdetail.id}` : ''
                    await axios[method](
                        `${baseApiUrl}/altertenantagreementfinancialdetails${id}`,
                        this.tenantagreementfinancialdetail
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.tenantagreementfinancialdetail = {}
                            this.loadFinancialDetail()
                 
                        })
                        .catch(showError)
            },
         

        },
        mounted(){

                this.start_date = moment()
                .add(-30, "d")
                .format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadFinancialDetail()
            this.showTable = true
        }
}
</script>

<style>


    .tenantagreement-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .tenantagreement-search button{
        font-size: 0.75rem;
    }

     .tenantagreement-search select{
        font-size: 0.75rem;
    }

    .tenantagreement-search input{
        font-size: 0.75rem;
    }

    .tenantagreement-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
